/* eslint-disable */

// @ts-nocheck
import Head from 'next/head';
import Script from 'next/script';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowBadge, setUnreadMessage } from 'ui/store/tasia/actions';
import { tasia } from '../../../assets/images';
import Image from 'next/image';
import BackToTop from '../Icons/BackToTop';
import eventTanyaTasia from 'ui/lib/gtm/eventTanyaTasia';
import useIsNativeView from '../../../hooks/useIsNativeView';
import cookie from '@boiseitguru/cookie-cutter';
import { IRootState } from '../../../store';

interface ITanyaTasiaProps {
  tasiaClassName?: string;
  backToTopClassName?: string;
  isBranchListingPage?: boolean;
  badgeBottomHeight?: string;
}

const TanyaTasia = ({
  tasiaClassName = 'bottom-[30px]',
  backToTopClassName = 'bottom-[30px]',
  isBranchListingPage = false,
  badgeBottomHeight,
}: ITanyaTasiaProps) => {
  const [hideTasia, setHideTasia] = useState(true);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const { isMobileScreen, screenSize } = useSelector((state: IRootState) => state.page);
  const { userData } = useSelector((state: IRootState) => state.auth);
  const isNativeView = useIsNativeView();

  const BASE_URL = process.env.NEXT_PUBLIC_URL;
  const TASIA_URL = process.env.NEXT_PUBLIC_TASIA_URL;
  const TASIA_MAP_KEY = process.env.NEXT_PUBLIC_TASIA_GOOGLE_MAP_KEY;

  const dispatch = useDispatch();

  useEffect(() => {
    const dolphinChat = document.getElementById('dolphin-chat');
    const dolphinMapModal = document.getElementById('dolphin-mapModal');
    if (dolphinChat) {
      dolphinChat.style.display = '';
    }
    if (dolphinMapModal) {
      dolphinMapModal.style.display = '';
    }
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const tasia = document.querySelector('#dolphin-chat-notification') as React.ReactHTMLElement;
      const unreadMessageText = tasia && tasia.textContent;
      const unreadMessage = unreadMessageText ? parseInt(unreadMessageText) : 0;

      const tasiaDisplay = tasia && tasia.style.display;

      if (tasia) {
        tasia.classList.add('invisible');
        tasia.classList.add('lg:visible');
      }

      dispatch(setUnreadMessage(unreadMessage));
      dispatch(setShowBadge(tasiaDisplay === 'block'));
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const tasia = document.querySelector('#dolphin-chat-notification') as React.ReactHTMLElement;

      if (tasia) {
        if (badgeBottomHeight) {
          tasia.style.bottom = badgeBottomHeight;
        } else {
          tasia.style.bottom = '60px';
        }
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
    });

    return () => observer.disconnect();
  }, [badgeBottomHeight, isMobileScreen]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const body = document.body;
      const tasia = document.querySelector('#dolphin-chat') as React.ReactHTMLElement;

      if (
        (body?.style?.position === 'fixed' || body?.style?.position === 'unset') &&
        body?.style?.overflow === 'hidden' &&
        (!tasia || tasia?.style?.display !== 'flex')
      ) {
        body.style.position = 'static';
        body.style.overflow = 'visible';
      } else if (tasia?.style?.display === 'flex' && isMobileScreen) {
        body.style.position = 'fixed';
        body.style.overflow = 'hidden';
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
    });

    return () => observer.disconnect();
  }, [isMobileScreen]);

  // Handle scroll event to show/hide the "Back to Top" button
  const handleScroll = () => {
    const isAtBottom =
      Math.round(window.innerHeight + window.scrollY + 20) >= document.body.offsetHeight;
    setIsBottom(isAtBottom);

    if (window.scrollY > 200) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  };

  const calculateBottom = (width) => {
    if (width >= 350 && width < 450) {
      return '143px';
    } else if (width >= 450 && width < 550) {
      return '158px';
    } else if (width >= 550 && width < 650) {
      return '173px';
    } else if (width >= 650 && width < 750) {
      return '188px';
    } else if (width >= 750) {
      return '203px';
    }
  };

  // Scroll to the top when the button is clicked
  const scrollToTop = () => {
    if (showBackToTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    // Add a scroll event listener when the component is mounted
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <React.Fragment>
      {!isNativeView && (
        <>
          <Head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, maximum-scale=1, interactive-widget=resizes-content"
            />
            <link
              rel="stylesheet prefetch"
              href="https://fonts.googleapis.com/css?family=Open+Sans"
            />
            <link rel="stylesheet" href={`${BASE_URL}/_ui/webchat-mobile/css/red.css`} />
            <link rel="stylesheet" href={`${BASE_URL}/_ui/webchat-mobile/css/widget.css`} />
            <link rel="stylesheet" href={`${BASE_URL}/_ui/webchat-mobile/css/lightslider.css`} />
            <link rel="stylesheet" href={`${BASE_URL}/_ui/webchat-mobile/css/intlTelInput.css`} />
            <link
              rel="stylesheet"
              href={`${BASE_URL}/_ui/responsive/theme-auto2000/css/webchat/auto2000red.css`}
            />
          </Head>
          <Script
            src="https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"
            strategy="lazyOnload"
            async
            onLoad={() => {
              const timestamp = Date.now();
              $(document).ready(function () {
                $.when(
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/fingerPrint.js`),
                  $.getScript(
                    `${BASE_URL}/_ui/responsive/common/js/webchat/iframeResizer.contentWindow.js`
                  ),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/iframeResizer.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/cryptojs/pbkdf2.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/lazyload.min.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/cryptojs/aes.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/cipher/aes-util.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/stp.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/sjs.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/fuse.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/speech.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/intlTelInput.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/utils.js`),
                  $.getScript(`${BASE_URL}/_ui/responsive/common/js/webchat/lightslider.js`),
                  $.getScript(
                    `${BASE_URL}/_ui/responsive/common/js/webchat/chat-20240808.js?v=${timestamp}`
                  ),

                  $.Deferred(function (deferred) {
                    $(deferred.resolve);
                  })
                ).done(function () {
                  let enableChat = false;

                  const cookieFunctions = {
                    getCookie: function getCookie(key) {
                      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
                      return keyValue ? keyValue[2] : null;
                    },
                    setCookie: function setCookie(key, value, expiry) {
                      var expires = new Date();
                      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
                      //document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
                      cookie.set(key, value, { expires: expires.toUTCString(), path: '/' });
                    },
                  };

                  function getCurrentCustomer() {
                    var customerTasia = cookieFunctions.getCookie('customerTasia');
                    if (customerTasia) {
                      var stringCustomer = atob(customerTasia);
                      var objCustomer = JSON.parse(stringCustomer);
                      if (objCustomer.name) {
                        startTasia(objCustomer);
                      } else {
                        startTasia(null);
                      }
                    } else {
                      startTasia(null);
                    }
                  }
                  getCurrentCustomer();

                  function startTasia(response) {
                    var isLogin = cookieFunctions.getCookie('isUserLoggedIn');
                    var name = null,
                      email = null,
                      phone = null,
                      guestName = '';
                    if (null != isLogin) {
                      if ('true' == isLogin && response && response.firstName) {
                        name = response.firstName;
                        email = response.customerEmail
                          ? response.customerEmail
                          : 'autofamily@gmail.com';
                        phone =
                          response.countryCode && response.phoneNumber
                            ? response.countryCode + response.phoneNumber
                            : '';
                      } else {
                        if (localStorage.getItem('name') !== 'Auto Family') {
                          guestName = 'Auto Family';
                          name = null;
                          email = null;
                          phone = null;
                          clearChatLocalStorage();
                          cookieFunctions.setCookie('isUserLoggedIn', null, 0);
                        }
                      }
                    } else {
                      if (localStorage.getItem('name') !== 'Auto Family') {
                        guestName = 'Auto Family';
                        name = null;
                        email = null;
                        phone = null;
                        cookieFunctions.setCookie('isUserLoggedIn', null, 0);
                        clearChatLocalStorage();
                      }
                    }
                    function _0x3c10() {
                      var _0x173e16 = [
                        'init',
                        'greeting\x20tasia',
                        process.env.NEXT_PUBLIC_BASE_URL + 'parameter/v1/tasia-init',
                        '196917BMPRfF',
                        '26zuRRuY',
                        '37825OkJIyK',
                        '2811816rxTWEl',
                        '429474OdsEbx',
                        'TASIA',
                        '10624hFYKBu',
                        '/_ui/responsive/theme-auto2000/images/webchat/tasia-blue.jpeg',
                        '2529BKgPcU',
                        '5622022ufgLoq',
                        '606QymHBG',
                        '5694490NRXaNc',
                      ];
                      _0x3c10 = function () {
                        return _0x173e16;
                      };
                      return _0x3c10();
                    }
                    function _0x2db8(_0xe06bb1, _0x481469) {
                      var _0x3c108f = _0x3c10();
                      return (
                        (_0x2db8 = function (_0x2db83b, _0x139944) {
                          _0x2db83b = _0x2db83b - 0xef;
                          var _0x20c055 = _0x3c108f[_0x2db83b];
                          return _0x20c055;
                        }),
                        _0x2db8(_0xe06bb1, _0x481469)
                      );
                    }
                    var _0x5086c3 = _0x2db8;
                    (function (_0x11c372, _0x4e5449) {
                      var _0x5c8f1c = _0x2db8,
                        _0x580d51 = _0x11c372();
                      while (!![]) {
                        try {
                          var _0x5636d7 =
                            parseInt(_0x5c8f1c(0xf4)) / 0x1 +
                            (-parseInt(_0x5c8f1c(0xf1)) / 0x2) * (parseInt(_0x5c8f1c(0xf0)) / 0x3) +
                            parseInt(_0x5c8f1c(0xf3)) / 0x4 +
                            (parseInt(_0x5c8f1c(0xf2)) / 0x5) * (parseInt(_0x5c8f1c(0xfa)) / 0x6) +
                            -parseInt(_0x5c8f1c(0xf9)) / 0x7 +
                            (-parseInt(_0x5c8f1c(0xf6)) / 0x8) * (parseInt(_0x5c8f1c(0xf8)) / 0x9) +
                            parseInt(_0x5c8f1c(0xfb)) / 0xa;
                          if (_0x5636d7 === _0x4e5449) break;
                          else _0x580d51['push'](_0x580d51['shift']());
                        } catch (_0x295341) {
                          _0x580d51['push'](_0x580d51['shift']());
                        }
                      }
                    })(_0x3c10, 0x6a861),
                      Chat[_0x5086c3(0xfc)]({
                        header: _0x5086c3(0xf5),
                        chat_sub_header: 'AUTO2000\x20VIRTUAL\x20ASSISTANT',
                        url: `${TASIA_URL}`,
                        compatibility_mode: !![],
                        triggerMenu: _0x5086c3(0xfd),
                        trigger_menu_after_icon_click: !![],
                        enable_history: ![],
                        enable_attachment: ![],
                        guestName: guestName,
                        type_placeholder: '',
                        avatar: _0x5086c3(0xf7),
                        icon_avatar: _0x5086c3(0xf7),
                        agent_avatar:
                          '/_ui/responsive/theme-auto2000/images/webchat/tasia-blue.jpeg',
                        enable_voice: ![],
                        enable_speech: ![],
                        enable_queue: ![],
                        lightSlider_settings: {
                          item: 0x2,
                          autoWidth: !![],
                          loop: ![],
                          responsive: [],
                          enableTouch: ![],
                          enableDrag: ![],
                          controls: ![],
                        },
                        third_party_token: _0x5086c3(0xef),
                      });
                    $(document).on('click', '#chat-icon', function (e) {
                      e.preventDefault();
                      if (!enableChat) return;
                      if (isEmptyData(localStorage.getItem('uid')) && isEmptyData(name)) {
                        Chat.guestName = 'Auto Family';
                      }
                      Chat.onIconClick();
                    });
                    localStorage.setItem('inmotion_chat_state', 'icon');

                    function dolphinLoginDataUser() {
                      if (!is_fingerprint_load_delay) {
                        if (localStorage.getItem('name') !== name) {
                          Chat.resetToLogin(true);
                          Chat.name = name;
                          Chat.email = email;
                          Chat.phone = phone;

                          if (isEmptyData(Chat.uid)) {
                            Chat.uid = Chat.generateUid();
                          }
                          if (isEmptyData(Chat.name)) {
                            Chat.name = Chat.uid;
                          }
                          if (isEmptyData(Chat.email)) {
                            Chat.email = Chat.uid + '@mail.com';
                          }
                          if (isEmptyData(Chat.phone)) {
                            Chat.phone = Chat.uid;
                          }

                          localStorage.setItem('name', Chat.name);
                          localStorage.setItem('email', Chat.email);
                          localStorage.setItem('phone', Chat.phone);
                          localStorage.setItem('uid', Chat.uid);
                        }
                      } else {
                        setTimeout(() => {
                          dolphinLoginDataUser();
                        }, 100);
                      }
                    }

                    if (isLogin == 'true') {
                      dolphinLoginDataUser();
                    }

                    function setAt() {
                      var tasiaAt = cookieFunctions.getCookie('tasiaAt');
                      if (tasiaAt) {
                        var stringAt = atob(tasiaAt);
                        var objAt = JSON.parse(stringAt);
                        if (objAt.expires_in) {
                          if (!objAt.expires_millies) {
                            objAt.expires_millies = Date.now() + objAt.expires_in * 1000;
                            stringAt = JSON.stringify(objAt);
                          }
                        }
                        localStorage.setItem('at', stringAt);
                        at = stringAt;
                        Chat.access_token = objAt.access_token;
                      }

                      setTimeout(() => {
                        setAt();
                      }, 400);
                    }
                    setAt();
                    setTimeout(() => {
                      setHideTasia(false);
                      enableChat = true;
                    }, 500);
                  }
                });

                // Load map script on pages except branch dealer page
                if (!isBranchListingPage) {
                  $.when(
                    $.getScript(
                      `https://maps.googleapis.com/maps/api/js?key=${TASIA_MAP_KEY}&libraries=places&language=id`
                    )
                  ).done(function () {
                    google.maps.event.addDomListener(window, 'load');
                  });
                }
              });
            }}
          />
        </>
      )}

      <div className="relative">
        <button
          id="button-top"
          aria-label="button-top"
          className={`fixed duration-300 ${
            showBackToTop ? ' translate-y-0 opacity-1' : ' translate-y-8 opacity-0'
          } right-4 lg:right-[213px] z-[21] ${backToTopClassName}`}
          style={{
            bottom: `${
              screenSize.width <= 1024
                ? isBottom
                  ? calculateBottom(screenSize.width)
                  : '86px'
                : ''
            }`,
          }}
          onClick={scrollToTop}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
        >
          <BackToTop />
        </button>
      </div>
      {!isMobileScreen && (
        <div
          className={`group fixed  right-10 justify-center hidden lg:block invisible lg:visible z-50 max-h-screen ${hideTasia ? 'hidden' : ''} ${tasiaClassName}`}
        >
          <button
            id="chat-icon"
            className="flex h-10 w-[160px] py-[10px] pl-[15px] pr-[58px] rounded-[10px] bg-[#d5d1d9] group-hover:bg-reliableBlack10 font-medium text-sm italic justify-center items-center whitespace-normal"
            onClick={() => eventTanyaTasia()}
          >
            Tanya Tasia
            <Image
              className="h-[60px] w-[54px] group-hover:h-[68px] group-hover:w-[60px] ml-3 absolute right-0 bottom-0"
              src={tasia.src}
              alt="tanya-tasia"
              width={100}
              height={100}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              quality={65}
              loading="lazy"
            />
          </button>
        </div>
      )}
    </React.Fragment>
  );
};

export default TanyaTasia;
